// MIT License - Copyright (c) 2026 Doug McNall

/**
 * Halo Universe - Aliens Configuration
 */

export const HaloAliensPlanets = {
  planets: {
    1800: ['spartan', 'unscmarine', 'cortana'],                // UNSC Infinity
    1801: ['spartan', 'elite', 'grunt', 'jackal'],              // Reach - battle site
    1802: ['unscmarine', 'spartan'],                           // Earth - UNSC homeworld
    1803: ['flood', 'forerunner', 'sentinel'],                  // Alpha Halo - Flood outbreak
    1804: ['flood', 'elite', 'brute', 'forerunner'],           // Delta Halo - Great Schism
    1805: ['flood', 'prophet', 'elite', 'grunt'],              // High Charity - Flood infested
    1806: ['elite', 'grunt', 'jackal'],                         // Sanghelios - Elite homeworld
    1807: ['grunt'],                                            // Balaho - Grunt homeworld
    1808: ['brute', 'grunt'],                                   // Doisac - Brute homeworld
    1809: ['forerunner', 'promethean', 'didact'],              // Requiem - Forerunner world
    1810: ['forerunner', 'sentinel', 'flood'],                  // The Ark - Halo forge
    1811: ['forerunner', 'sentinel', 'spartan']                 // Onyx - Shield world
  },
  randomEncounters: ['covenant', 'flood', 'promethean'],
  hostileSpecies: ['flood', 'covenant', 'promethean', 'brute'],
  friendlyTraders: ['unscmarine', 'elite', 'grunt']
};

export default HaloAliensPlanets;
